






















import {Component} from "vue-property-decorator";
import InvitesList from "../../share/invites/InvitesList.vue";
import CreateMeeting from "../../share/meeting-form/CreateMeeting.vue";
import MeetingDetail from "./components/detail/MeetingDetail.vue";
import PocketBlock from "../../share/common/pocket/Pocket.vue";
import AnalyticsMixin from "../../mixins/AnalyticsMixin";

@Component({
    name: 'MeetingsWrapper',
    components: { InvitesList, PocketBlock, CreateMeeting, MeetingDetail }
})
export default class MeetingsWrapper extends AnalyticsMixin {

    showCreate = false;
    showDetail = false;
    showList = true;
    selectedMeetingId: string | null = null;

    mounted() {
        if(this.routeHash.startsWith('#meetings_')) {
            this.selectedMeetingId = this.routeHash.replace(/#meetings_/g, '')
            this.showDetail = true;
            this.showList = false;
        }

        if(this.routeQuery?.userId) {
            this.setShowCreate();
        }
    }

    backFromDetail() {
        this.showList = true;
        this.selectedMeetingId = null;
        this.showDetail = false;
    }

    backFromNewMeeting() {
        this.showList = true;
        this.showDetail = false;
        this.showCreate = false;
    }

    selectMeeting(inviteId: string) {
        this.showDetail = true;
        this.showList = false;
        this.selectedMeetingId = inviteId;
    }

    close() {
        this.sendScreenView(this.$store.state.screenNameData?.prevName || this.$route.meta?.analyticName);
        this.$emit('close');
    }

    newMeeting({time, date}: any) {
        const query: any = {};
        if (time) {
            query['time'] = time as string;
        }
        if (date) {
            query['date'] = date as string;
        }

        this.$router.push({
            query,
            hash: this.$route.hash
        });

        this.setShowCreate();
    }

    setShowCreate() {
        this.showCreate = true;
        this.showList = false;
    }

    get eventId() {
        return this.$store.state.events.selected;
    }

    get key() {
        return 'invites_' + this.eventId;
    }

    get routeHash() {
        return this.$route.hash;
    }

    get routeQuery() {
        return this.$route.query
    }
}

